import club_logo from "./club_logo.png";
import email_logo from './email_logo.png';
import instagram_logo from './instagram_logo.png';

var instagram_path = "https://www.instagram.com/uoftea.party/";

export { club_logo, email_logo, instagram_logo, instagram_path};